export default __webpack_public_path__ + "images/5582f04b57f815d25fad192b0812cc19.png";